import { stringify } from '../../../../core/utils/query-string'
import {
  CitiesRequestFilters,
  CityData,
  PaginatedData,
  RequestOptions,
} from '../../../../types/interfaces'
import { client } from '../../client'

export class CitiesService {
  public async getCities(
    filters?: CitiesRequestFilters,
    options?: RequestOptions
  ) {
    return client.get<PaginatedData<CityData[]>>(
      `/cities?${stringify(filters as object)}`,
      options
    )
  }

  public async getCityById(cityId: number) {
    return client.get<CityData>(`/cities/${cityId}`)
  }
}
